import { InteractionRequiredAuthError, type IPublicClientApplication } from '@azure/msal-browser';
import { setAccessTokenProvider, setRequestSucceededHandler, setUnauthorizedHandler } from '../api/http';
import { noteSuccessfulRequest, noteUnauthorizedRound } from './loginLoop';
import { apiTokenRequest, loginRequest } from './msalConfig';

/**
 * Points the HTTP layer at MSAL. Kept out of http.ts so the wrapper stays testable with a stub
 * token provider and carries no dependency on the identity library.
 */
export function configureApiAuth(instance: IPublicClientApplication): void {
  setAccessTokenProvider(async ({ forceRefresh }) => {
    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];

    if (!account) {
      await instance.loginRedirect(loginRequest);
      throw new Error('No signed-in account; redirecting to sign in.');
    }

    try {
      const result = await instance.acquireTokenSilent({
        ...apiTokenRequest,
        account,
        forceRefresh: forceRefresh ?? false,
      });
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await instance.acquireTokenRedirect({ ...apiTokenRequest, account });
      }
      throw error;
    }
  });

  setUnauthorizedHandler(() => {
    if (noteUnauthorizedRound() === 'redirect') {
      void instance.loginRedirect(loginRequest).catch((error: unknown) => {
        console.error('Sign-in redirect failed.', error);
      });
    }
  });
  setRequestSucceededHandler(noteSuccessfulRequest);
}
